import React, { useState } from "react";
import {
  getAllPlans,
  createPlan,
  createUserSubscription,
  updateCreditBalance,
  logTransaction,
  resetCredits,
  useQuery,
  getUserSubscriptions,
  cancelSubscription,
  getEnrichments,
  createEnrichment,
  updateEnrichment,
  deleteEnrichment,
  deletePlan,
} from "wasp/client/operations";

export default function TestPage() {
  const [planFormData, setPlanFormData] = useState({
    name: "",
    type: "ESSENTIAL",
    creditsPerPeriod: 1000,
    billingInterval: "MONTHLY", // Yeni eklenen alan
  });

  const [subscriptionFormData, setSubscriptionFormData] = useState({
    userId: "",
    planId: 0,
  });

  const [creditFormData, setCreditFormData] = useState({
    userId: "",
    subscriptionId: 0,
    creditsChange: 0,
  });

  const {
    data: plans,
    isLoading: plansLoading,
    error: plansError,
  } = useQuery(getAllPlans);
  const { data: subscriptions, isLoading: subsLoading } = useQuery(
    getUserSubscriptions,
    { userId: "test-user" }
  );

  const handleCreatePlan = async (e: any) => {
    e.preventDefault();
    try {
      const result = await createPlan(planFormData);
      console.log("Plan created:", result);
      alert("Plan created successfully!");
    } catch (err: any) {
      console.error("Error creating plan:", err);
      alert("Error creating plan: " + err.message);
    }
  };

  const handleDeletePlan = async (planId: number) => {
    try {
      const result = await deletePlan({ planId: planId });
      console.log("Plan created:", result);
      alert("Plan created successfully!");
    } catch (err: any) {
      console.error("Error creating plan:", err);
      alert("Error creating plan: " + err.message);
    }
  };

  const handleCreateSubscription = async (e: any) => {
    e.preventDefault();
    try {
      //const result = await createUserSubscription(subscriptionFormData);
      console.log("Subscription created:");
      alert("Subscription creation disabled!");
    } catch (err: any) {
      console.error("Error creating subscription:", err);
      alert("Error creating subscription: " + err.message);
    }
  };

  const handleUpdateCredits = async (e: any) => {
    e.preventDefault();
    try {
      const result = await updateCreditBalance(creditFormData as any);
      console.log("Credits updated:", result);
      alert("Credits updated successfully!");
    } catch (err: any) {
      console.error("Error updating credits:", err);
      alert("Error updating credits: " + err.message);
    }
  };

  const [enrichmentFormData, setEnrichmentFormData] = useState({
    key: "",
    value: 0,
    mfrMultiplier: {
      key: "",
      value: 0,
    },
  });

  // useQuery eklemeleri
  const { data: enrichments, isLoading: enrichmentsLoading } =
    useQuery(getEnrichments);

  // Form handler eklemeleri
  const handleCreateEnrichment = async (e: any) => {
    e.preventDefault();
    try {
      const result = await createEnrichment(enrichmentFormData);
      console.log("Enrichment created:", result);
      alert("Enrichment created successfully!");
    } catch (err: any) {
      console.error("Error creating enrichment:", err);
      alert("Error creating enrichment: " + err.message);
    }
  };

  if (plansLoading || subsLoading) return <div>Loading...</div>;
  if (plansError) return <div>Error: {plansError.message}</div>;

  return (
    <div className="max-w-4xl mx-auto p-4">
      <h1 className="text-2xl font-bold mb-4">Credit Management Test Page</h1>

      {/* Create Plan Form */}
      <div className="mb-8 p-4 border rounded">
        <h2 className="text-xl font-semibold mb-4">Create Plan</h2>
        <form onSubmit={handleCreatePlan} className="space-y-4">
          <div>
            <label className="block mb-1">Name:</label>
            <input
              type="text"
              value={planFormData.name}
              onChange={(e) =>
                setPlanFormData({ ...planFormData, name: e.target.value })
              }
              className="border p-2 w-full"
            />
          </div>
          <div>
            <label className="block mb-1">Type:</label>
            <select
              value={planFormData.type}
              onChange={(e) =>
                setPlanFormData({ ...planFormData, type: e.target.value })
              }
              className="border p-2 w-full"
            >
              <option value="ESSENTIAL">Essential</option>
              <option value="ADVANCED">Advanced</option>
              <option value="PROFESSIONAL">Professional</option>
              <option value="TRIAL">Trial</option>
            </select>
          </div>
          <div>
            <label className="block mb-1">Credits Per Period:</label>
            <input
              type="number"
              value={planFormData.creditsPerPeriod}
              onChange={(e) =>
                setPlanFormData({
                  ...planFormData,
                  creditsPerPeriod: parseInt(e.target.value),
                })
              }
              className="border p-2 w-full"
            />
          </div>
          <div>
            <label className="block mb-1">Billing Interval:</label>
            <select
              value={planFormData.billingInterval}
              onChange={(e) =>
                setPlanFormData({
                  ...planFormData,
                  billingInterval: e.target.value,
                })
              }
              className="border p-2 w-full"
            >
              <option value="MONTHLY">Monthly</option>
              <option value="YEARLY">Yearly</option>
            </select>
          </div>

          <button
            type="submit"
            className="bg-blue-500 text-white px-4 py-2 rounded"
          >
            Create Plan
          </button>
        </form>
      </div>

      {/* Create Subscription Form */}
      <div className="mb-8 p-4 border rounded">
        <h2 className="text-xl font-semibold mb-4">Create Subscription</h2>
        <form onSubmit={handleCreateSubscription} className="space-y-4">
          <div>
            <label className="block mb-1">User ID:</label>
            <input
              type="text"
              value={subscriptionFormData.userId}
              onChange={(e) =>
                setSubscriptionFormData({
                  ...subscriptionFormData,
                  userId: e.target.value,
                })
              }
              className="border p-2 w-full"
            />
          </div>
          <div>
            <label className="block mb-1">Plan:</label>
            <select
              value={subscriptionFormData.planId}
              onChange={(e) =>
                setSubscriptionFormData({
                  ...subscriptionFormData,
                  planId: parseInt(e.target.value),
                })
              }
              className="border p-2 w-full"
            >
              <option value={0}>Select a plan</option>
              {plans?.map((plan: any) => (
                <option key={plan.id} value={plan.id}>
                  {plan.name} ({plan.creditsPerPeriod} credits)
                </option>
              ))}
            </select>
          </div>
          <button
            type="submit"
            className="bg-green-500 text-white px-4 py-2 rounded"
          >
            Create Subscription
          </button>
        </form>
      </div>

      {/* Update Credits Form */}
      <div className="mb-8 p-4 border rounded">
        <h2 className="text-xl font-semibold mb-4">Update Credits</h2>
        <form onSubmit={handleUpdateCredits} className="space-y-4">
          <div>
            <label className="block mb-1">User ID:</label>
            <input
              type="text"
              value={creditFormData.userId}
              onChange={(e) =>
                setCreditFormData({ ...creditFormData, userId: e.target.value })
              }
              className="border p-2 w-full"
            />
          </div>
          <div>
            <label className="block mb-1">Subscription:</label>
            <select
              value={creditFormData.subscriptionId}
              onChange={(e) =>
                setCreditFormData({
                  ...creditFormData,
                  subscriptionId: parseInt(e.target.value),
                })
              }
              className="border p-2 w-full"
            >
              <option value={0}>Select a subscription</option>
              {subscriptions?.map((sub) => (
                <option key={sub.id} value={sub.id}>
                  {sub.plan.name} (ID: {sub.id})
                </option>
              ))}
            </select>
          </div>
          <div>
            <label className="block mb-1">Credits Change:</label>
            <input
              type="number"
              value={creditFormData.creditsChange}
              onChange={(e) =>
                setCreditFormData({
                  ...creditFormData,
                  creditsChange: parseInt(e.target.value),
                })
              }
              className="border p-2 w-full"
            />
          </div>
          <button
            type="submit"
            className="bg-purple-500 text-white px-4 py-2 rounded"
          >
            Update Credits
          </button>
        </form>
      </div>

      {/* Display Current Plans */}
      <div className="mb-8 p-4 border rounded">
        <h2 className="text-xl font-semibold mb-4">Current Plans</h2>
        <div className="space-y-2">
          {plans?.map((plan: any) => (
            <div key={plan.id} className="p-2 border rounded">
              <p>
                <strong>Name:</strong> {plan.name}
              </p>
              <p>
                <strong>Type:</strong> {plan.type}
              </p>
              <p>
                <strong>Credits:</strong> {plan.creditsPerPeriod}
              </p>
              <p>
                <strong>Renewal Period:</strong> {plan.creditResetDays} days
              </p>
              <button
                onClick={() => {
                  handleDeletePlan(plan.id);
                }}
              >
                Delete
              </button>
            </div>
          ))}
        </div>
      </div>

      {/* Display Current Subscriptions */}
      <div className="mb-8 p-4 border rounded">
        <h2 className="text-xl font-semibold mb-4">Current Subscriptions</h2>
        <div className="space-y-2">
          {subscriptions?.map((sub) => (
            <div key={sub.id} className="p-2 border rounded">
              <p>
                <strong>ID:</strong> {sub.id}
              </p>
              <p>
                <strong>User ID:</strong> {sub.userId}
              </p>
              <p>
                <strong>Plan:</strong> {sub.plan.name}
              </p>
              <p>
                <strong>Status:</strong> {sub.isActive ? "Active" : "Inactive"}
              </p>
              <p>
                <strong>Current Credits:</strong>{" "}
                {sub.creditBalances?.[0]?.remainingCredits || 0}
              </p>
              <button
                onClick={() =>
                  cancelSubscription({
                    subscriptionId: sub.id,
                    userId: sub.userId,
                  })
                }
                className="bg-red-500 text-white px-4 py-2 rounded mt-2"
              >
                Cancel Subscription
              </button>
            </div>
          ))}
        </div>
      </div>
      <div className="mb-8 p-4 border rounded">
        <h2 className="text-xl font-semibold mb-4">Create Enrichment Value</h2>
        <form onSubmit={handleCreateEnrichment} className="space-y-4">
          <div>
            <label className="block mb-1">Key:</label>
            <input
              type="text"
              value={enrichmentFormData.key}
              onChange={(e) =>
                setEnrichmentFormData({
                  ...enrichmentFormData,
                  key: e.target.value,
                })
              }
              className="border p-2 w-full"
            />
          </div>
          <div>
            <label className="block mb-1">Value:</label>
            <input
              type="number"
              value={enrichmentFormData.value}
              onChange={(e) =>
                setEnrichmentFormData({
                  ...enrichmentFormData,
                  value: parseInt(e.target.value),
                })
              }
              className="border p-2 w-full"
            />
          </div>

          <div className="mt-4 p-4 bg-gray-50 rounded">
            <h3 className="text-lg font-medium mb-2">
              Market Facts Radar Multiplier
            </h3>
            <div className="space-y-4">
              <div>
                <label className="block mb-1">Multiplier Key:</label>
                <input
                  type="text"
                  value={enrichmentFormData.mfrMultiplier.key}
                  onChange={(e) =>
                    setEnrichmentFormData({
                      ...enrichmentFormData,
                      mfrMultiplier: {
                        ...enrichmentFormData.mfrMultiplier,
                        key: e.target.value,
                      },
                    })
                  }
                  className="border p-2 w-full"
                />
              </div>
              <div>
                <label className="block mb-1">Multiplier Value:</label>
                <input
                  type="number"
                  value={enrichmentFormData.mfrMultiplier.value}
                  onChange={(e) =>
                    setEnrichmentFormData({
                      ...enrichmentFormData,
                      mfrMultiplier: {
                        ...enrichmentFormData.mfrMultiplier,
                        value: parseInt(e.target.value),
                      },
                    })
                  }
                  className="border p-2 w-full"
                />
              </div>
            </div>
          </div>

          <button
            type="submit"
            className="bg-indigo-500 text-white px-4 py-2 rounded"
          >
            Create Enrichment
          </button>
        </form>
      </div>

      {/* Display Current Enrichments */}
      <div className="mb-8 p-4 border rounded">
        <h2 className="text-xl font-semibold mb-4">Current Enrichments</h2>
        {enrichmentsLoading ? (
          <div>Loading enrichments...</div>
        ) : (
          <div className="space-y-2">
            {(enrichments as any[])?.map((enrichment: any) => (
              <div key={enrichment.id} className="p-2 border rounded">
                <p>
                  <strong>Key:</strong> {enrichment.key}
                </p>
                <p>
                  <strong>Value:</strong> {enrichment.value}
                </p>
                {enrichment.mfrMultiplier && (
                  <div className="mt-2 pl-4 border-l-2">
                    <p className="font-medium">Multiplier:</p>
                    <p>
                      <strong>Key:</strong> {enrichment.mfrMultiplier.key}
                    </p>
                    <p>
                      <strong>Value:</strong> {enrichment.mfrMultiplier.value}
                    </p>
                  </div>
                )}
                <div className="mt-2 space-x-2">
                  <button
                    onClick={() =>
                      updateEnrichment({
                        id: enrichment.id,
                        key: enrichment.key,
                        value: enrichment.value + 1,
                      })
                    }
                    className="bg-yellow-500 text-white px-3 py-1 rounded text-sm"
                  >
                    Update
                  </button>
                  <button
                    onClick={() => deleteEnrichment({ id: enrichment.id })}
                    className="bg-red-500 text-white px-3 py-1 rounded text-sm"
                  >
                    Delete
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
